// Units covered by an RMA case (issue #712). Mirrors backend/utils/rmaDevices.js.
// Cases created before multi-device support have an empty devices[] and are
// described by the top-level serialNumber — read everything through
// deviceList() so both shapes render identically.

export const REPAIR_DONE_STATES = ['repaired', 'scrapped', 'no_fault'];

export const REPAIR_STATE_LABELS = {
  pending: 'Not finished',
  repaired: 'Repaired',
  scrapped: 'Scrapped',
  no_fault: 'No fault found',
};

export function deviceList(rma) {
  if (!rma) return [];
  const devices = Array.isArray(rma.devices) ? rma.devices : [];
  if (devices.length) return devices;
  if (!rma.serialNumber) return [];
  return [{
    serialNumber: rma.serialNumber,
    productNumber: rma.productNumber || '',
    issueType: rma.issueType || 'hardware',
    description: rma.description || '',
    isPrimary: true,
    repair: { state: 'pending' },
  }];
}

export function isDeviceDone(device) {
  return REPAIR_DONE_STATES.includes(device?.repair?.state);
}

// { done, total } — the "1/6 repaired" counter.
export function repairProgress(rma) {
  const devices = deviceList(rma);
  // A single-unit case has no per-unit checklist — case-level repair decides.
  if (!Array.isArray(rma?.devices) || rma.devices.length <= 1) {
    return { done: rma?.repair?.finalizedAt ? 1 : 0, total: devices.length || 1 };
  }
  return { done: devices.filter(isDeviceDone).length, total: devices.length };
}

// Only a real bundle is gated on per-unit completion; a single-unit case must
// never be blocked, since no per-unit UI is rendered for it.
export function allDevicesResolved(rma) {
  if (!Array.isArray(rma?.devices) || rma.devices.length <= 1) return true;
  return rma.devices.every(isDeviceDone);
}

export function isMultiDevice(rma) {
  return Array.isArray(rma?.devices) && rma.devices.length > 1;
}

export function deviceCount(rma) {
  return deviceList(rma).length;
}
